import { Component, OnInit } from '@angular/core';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-paytm-payment-details',
  templateUrl: './paytm-payment-details.component.html',
  styleUrls: ['./paytm-payment-details.component.scss']
})
export class PaytmPaymentDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }


  makePayment(){
    var url = "https://us-central1-drbeen-9d4d8.cloudfunctions.net/app/paywithpaytm?amount=10";
    var win = window.open(url, '_self');
    win.opener = null;
    win.focus();
  }



  
}
